define('OutSystems/ClientRuntime/modules/LogTable/LogTableInitializer',["require", "exports", "tslib", "../../Logger", "./LogTableInfo"], function (require, exports, tslib_1, Logger, LogTableInfo_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var LogTableInitializer = {
        isNeeded: function (tx) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, tx.existsTable(LogTableInfo_1.default)];
                    case 1: return [2, !(_a.sent())];
                }
            });
        }); },
        run: function (tx) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Logger.trace(this, "Running initializer for log table info table.");
                        return [4, tx.createTable(LogTableInfo_1.default)];
                    case 1:
                        _a.sent();
                        Logger.trace(this, "Initializer for entity log table info table ran successfuly.");
                        return [2];
                }
            });
        }); },
    };
    exports.default = LogTableInitializer;
});
//# sourceMappingURL=LogTableInitializer.js.map;
